import {  Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArraysHelper  {

  emptyItemRemove(data: any, noRemove: Array<string> = [], removeEmpty: boolean = true, removeNull: boolean = true){
      let newData = Object.assign(data, {});

      let isArray = Array.isArray(data);
      if(isArray){
          for(let i=0; i < data.length; i++){
              this.emptyItemRemove(data[i]);
          }
      }else{
          for(var key in newData) {
              var valueItem = newData[key];
              if(Array.isArray(valueItem)){
                  for(let i=0; i < valueItem.length; i++){
                      this.emptyItemRemove(valueItem[i]);
                  }
              }else{
                 // console.log(key);
                 // console.log(valueItem);
                  //console.log("/////");
                  if( (valueItem === '' && removeEmpty === true) || (valueItem === null && removeNull === true)){
                      if(noRemove.indexOf(key) == -1){

                          delete newData[key];
                      }
                  }
              }
          }
      }
      return newData;
  }

  emptyItemReplace(data: any, replaceFrom: string, replaceTo: string){
      let newData = Object.assign(data, {});

      let isArray = Array.isArray(data);
      if(isArray){
          for(let i=0; i < data.length; i++){
              this.emptyItemReplace(data[i], replaceFrom, replaceTo);
          }
      }else{
          for(var key in newData) {
              var valueItem = newData[key];
              if(Array.isArray(valueItem)){
                  for(let i=0; i < valueItem.length; i++){
                      this.emptyItemReplace(valueItem[i], replaceFrom, replaceTo);
                  }
              }else{
                  if(valueItem === replaceFrom){
                      newData[key] = replaceTo;
                  }
              }
          }
      }
      return newData;
  }

  serializeDate(dates){
      let dt = dates.map(element => {
          return (new Date(element.dateStartEvent) as Date).toLocaleString('pt-BR', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        });
      return dt.join('/');
  }

  serializeDate2(dates){
      let dt = dates.map(element => {
          return element.dateStartEvent; // return (new Date(element.dateStartEvent) as Date).toLocaleString('pt-BR', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        });
      return dt; //.join('/');
  }

  dateTimeBR(date){
      return new Date(date).toLocaleString();
  }

  toCurrency(value: number){
      // return (value == null) ? 0 : value.toFixed(2).toString().replace('.', ',');
      return (value == null) ? '0,00' : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }
}
